<div class="tax-popup">
  <div class="tax-header">
    <h2 class="header-text">{{ 'settings.taxExemptionPreview.title' | translate }}</h2>
    <a class="close-button" cdkFocusInitial (click)="dialogRef.close()">
      <img
        src="../../../../../assets/img/icons/svgs/close.svg"
        alt="{{ 'settings.taxExemptionPreview.closeAlt' | translate }}"
      />
    </a>
  </div>

  <div class="tax-warning">
    <div class="warning-icon">
      <img
        src="../../../../../assets/img/icons/svgs/red-circle-warning-icon.svg"
        alt="{{ 'settings.taxExemptionPreview.warningAlt' | translate }}"
      />
    </div>
    <div class="tax-warning-text-container">
      <span>{{ 'settings.taxExemptionPreview.warning1' | translate }}</span>
      <span>{{ 'settings.taxExemptionPreview.warning2' | translate }}</span>
      <span>{{ 'settings.taxExemptionPreview.warning3' | translate }}</span>
    </div>
  </div>

  <div class="tax-investor-info tw-uppercase">
    <div class="info-title">
      <span>{{ 'settings.taxExemptionPreview.investorInformation' | translate }}</span>
    </div>
    <div class="info-container">
      <div class="info-subcontainer">
        <div class="info-label">
          <span>{{ 'settings.taxExemptionPreview.fullNameAsPerIC' | translate }}</span>
        </div>
        <div class="info-value">
          <span class="tw-uppercase">{{ data?.investorName }}</span>
        </div>
      </div>
      <div class="info-subcontainer">
        <div class="info-label">
          <span>{{ 'settings.taxExemptionPreview.nricNumber' | translate }}</span>
        </div>
        <div class="info-value">
          <span>{{ data?.investorIdentityNumber }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="tax-investor-info tw-uppercase">
    <div class="info-title">
      <span>{{ 'settings.taxExemptionPreview.systemGeneratedData' | translate }}</span>
    </div>
    <div class="info-container">
      <div class="info-subcontainer">
        <div class="info-label">
          <span>{{ 'settings.taxExemptionPreview.operatorName' | translate }}</span>
        </div>
        <div class="info-value">
          <span class="tw-uppercase">{{ 'common.pitchPlatformsSdnBhd' | translate }}</span>
        </div>
      </div>
      <div class="info-subcontainer">
        <div class="info-label">
          <span>{{ 'settings.taxExemptionPreview.investeeCompany' | translate }}</span>
        </div>
        <div class="info-value">
          <span class="tw-uppercase">{{ data?.issuerName }}</span>
        </div>
      </div>
      <div class="info-subcontainer">
        <div class="info-label">
          <span>{{ 'settings.taxExemptionPreview.investeeCompanyBrnRoc' | translate }}</span>
        </div>
        <div class="info-value">
          <span>{{ data?.companyBrnRoc || '-' }}</span>
        </div>
      </div>
      <div class="info-subcontainer">
        <div class="info-label">
          <span>{{ 'settings.taxExemptionPreview.investmentAmount' | translate }}</span>
        </div>
        <div class="info-value">
          <span>{{ data?.transactionAmount | currency }}</span>
        </div>
      </div>
      <div class="info-subcontainer">
        <div class="info-label">
          <span>{{ 'settings.taxExemptionPreview.investmentDate' | translate }}</span>
        </div>
        <div class="info-value">
          <span>{{ data?.transactionDate | date: 'dd/MM/yyyy' }}</span>
        </div>
      </div>
      <div class="info-subcontainer">
        <div class="info-label">
          <span>{{ 'settings.taxExemptionPreview.modeOfInvestment' | translate }}</span>
        </div>
        <div class="info-value">
          <span class="tw-uppercase">{{ data?.modeOfInvestment }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="tax-footer">
    <button class="tax-button generate-button" (click)="generate()">
      <img
        src="../../../../../assets/img/icons/svgs/white-circle-tick-icon.svg"
        alt="{{ 'settings.taxExemptionPreview.generateAlt' | translate }}"
        class="tw-pr-2"
      />
      {{ 'settings.taxExemptionPreview.confirmGenerate' | translate }}
    </button>
    <a
      class="tax-button edit-button"
      href="https://forms.clickup.com/9008241541/f/8cexpw5-95236/95AP51LSN05VIUAFYI"
      target="_blank"
      rel="noopener noreferrer"
      (click)="dialogRef.close()"
    >
      <img
        src="../../../../../assets/img/icons/svgs/black-circle-warning-icon.svg"
        alt="{{ 'settings.taxExemptionPreview.editInformationAlt' | translate }}"
        class="tw-pr-2"
      />{{ 'settings.taxExemptionPreview.editMyInformation' | translate }}
    </a>
  </div>
</div>
